/**
 * Il widget di chat di Chatwoot.
 *
 * L'indirizzo e il token arrivano dall'ambiente e non sono scritti in
 * `index.html`: il server Chatwoot di sviluppo e quello di produzione sono
 * diversi, e in produzione la pagina è servita in https — il browser
 * bloccherebbe uno script caricato da un indirizzo http. Senza le due variabili
 * il widget semplicemente non c'è.
 */
declare global {
  interface Window {
    chatwootSDK?: { run: (options: { websiteToken: string; baseUrl: string }) => void };
  }
}

export function loadChatwoot(): void {
  const baseUrl = import.meta.env.VITE_CHATWOOT_BASE_URL?.replace(/\/$/, "");
  const websiteToken = import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN;
  if (!baseUrl || !websiteToken) return;

  const script = document.createElement("script");
  script.src = `${baseUrl}/packs/js/sdk.js`;
  script.async = true;
  script.onload = () => window.chatwootSDK?.run({ websiteToken, baseUrl });
  document.head.appendChild(script);
}
